export default class UpdatablePromise {
  constructor() {
    this.queue = [];
    this.data = null;
    this.isResolved = false;
  }

  resolve(data) {
    this.data = data;
    this.isResolved = true;
    this.executeQueue();
  }

  executeQueue() {
    while (this.queue.length > 0) {
      const callback = this.queue.shift();
      callback(this.data);
    }
  }

  then(callback) {
    if (this.isResolved) {
      callback(this.data);
    } else {
      this.queue.push(callback);
    }

    return this;
  }

  update(data) {
    this.data = data;
    this.executeQueue();
  }
}
